/*============================================================================
  YAMA product options (replaces the VO Product Options app)
  Markup: snippets/ymg-product-options.liquid

  - Button/swatch pickers are radio inputs with data-single-option-selector, so
    theme.js (slate.Variants) still handles price, photo and sold-out changes.
    This file only marks values that can't be bought with the other choices.
  - Add-ons: on submit, the main item and the chosen add-on variants go to
    /cart/add.js together. The main line gets a hidden _ymg_bundle id; each
    add-on gets the same id in _ymg_bundle_of plus a visible "For" property.
    assets/ymg-cart-addons.js keeps add-on quantities in step on the cart page.
==============================================================================*/
(function() {
  if (window.ymgProductOptions) return;
  window.ymgProductOptions = true;

  function closestSection(el) {
    return el.closest('[data-section-type="product"]') || document;
  }

  function productJson(section) {
    var node = section.querySelector('[data-product-json]');
    try { return node ? JSON.parse(node.textContent) : null; } catch (e) { return null; }
  }

  /* Pickers ---------------------------------------------------------------- */

  function currentOptions(form) {
    var chosen = {};
    form.querySelectorAll('[data-single-option-selector]').forEach(function(input) {
      if (input.type === 'radio' && !input.checked) return;
      chosen[input.getAttribute('data-index')] = input.value;
    });
    return chosen;
  }

  function markUnavailable(form, product) {
    if (!product || !product.variants) return;
    var chosen = currentOptions(form);
    form.querySelectorAll('.ymg-picker__input').forEach(function(input) {
      var index = input.getAttribute('data-index');
      var available = product.variants.some(function(variant) {
        if (!variant.available || variant[index] !== input.value) return false;
        return Object.keys(chosen).every(function(key) {
          return key === index || variant[key] === chosen[key];
        });
      });
      var label = form.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.toggle('is-unavailable', !available);
    });
    form.querySelectorAll('[data-ymg-swatch-name]').forEach(function(name) {
      var checked = name.closest('fieldset').querySelector('.ymg-picker__input:checked');
      if (checked) name.textContent = checked.value;
    });
  }

  /* Add-ons ---------------------------------------------------------------- */

  function selectedChoices(group) {
    var select = group.querySelector('select[data-ymg-addon-input]');
    if (select) {
      var opt = select.options[select.selectedIndex];
      return opt && opt.value !== '' ? [opt] : [];
    }
    return Array.prototype.filter.call(group.querySelectorAll('input[data-ymg-addon-input]'), function(input) {
      return input.checked;
    });
  }

  // Groups and messages with data-show-option/-value (a product option) and/or
  // data-show-choice (an add-on choice handle). A group can depend on another
  // group, so repeat until nothing changes.
  function updateConditions(form) {
    var options = {};
    form.querySelectorAll('[data-option-name]').forEach(function(input) {
      if (input.type === 'radio' && !input.checked) return;
      options[input.getAttribute('data-option-name')] = input.value;
    });
    var items = form.querySelectorAll('[data-ymg-conditional]');
    for (var pass = 0; pass < 5; pass++) {
      var picked = {};
      form.querySelectorAll('[data-ymg-addon-group]').forEach(function(group) {
        if (group.hidden) return;
        selectedChoices(group).forEach(function(choice) { picked[choice.value] = true; });
      });
      var changed = false;
      items.forEach(function(el) {
        var option = el.getAttribute('data-show-option');
        var choice = el.getAttribute('data-show-choice');
        var show = (!option || options[option] === el.getAttribute('data-show-value')) && (!choice || !!picked[choice]);
        if (el.hidden === show) { el.hidden = !show; changed = true; }
      });
      if (!changed) break;
    }
  }

  function validate(wrapper) {
    var firstBad = null;
    wrapper.querySelectorAll('[data-ymg-addon-group]').forEach(function(group) {
      var error = group.querySelector('[data-ymg-addon-error]');
      var bad = !group.hidden && group.hasAttribute('data-required') && selectedChoices(group).length === 0;
      if (error) error.hidden = !bad;
      group.classList.toggle('has-error', bad);
      if (bad && !firstBad) firstBad = group;
    });
    if (firstBad) {
      firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var input = firstBad.querySelector('select, input');
      if (input) input.focus({ preventScroll: true });
    }
    return !firstBad;
  }

  function addonVariantIds(wrapper) {
    var ids = [];
    wrapper.querySelectorAll('[data-ymg-addon-group]').forEach(function(group) {
      if (group.hidden) return;
      selectedChoices(group).forEach(function(choice) {
        var id = parseInt(choice.getAttribute('data-variant'), 10);
        if (id) ids.push(id);
      });
    });
    return ids;
  }

  function showCartError(form, message) {
    var el = form.querySelector('[data-ymg-cart-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  function submitWithAddons(form, product, addonIds) {
    var button = form.querySelector('[data-add-to-cart]');
    var mainId = parseInt(form.querySelector('[name="id"]').value, 10);
    var qty = Math.max(1, parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1);
    var bundle = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

    var properties = {};
    new FormData(form).forEach(function(value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value !== '') properties[m[1]] = value;
    });
    properties._ymg_bundle = bundle;

    var variant = (product.variants || []).filter(function(v) { return v.id === mainId; })[0];
    var forText = product.title + (variant && variant.title !== 'Default Title' ? ' (' + variant.title + ')' : '');

    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var mainError = '';

    if (button) button.disabled = true;
    showCartError(form, '');

    // Main item first: stock can cap the quantity, and add-ons should match what actually went in
    cartAdd(root, [{ id: mainId, quantity: qty, properties: properties }]).then(function(result) {
      if (!result.ok) mainError = result.data.description || result.data.message || '';
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(res) { return res.json(); });
    }).then(function(cart) {
      var added = cart.items.reduce(function(sum, item) {
        return sum + (item.properties && item.properties._ymg_bundle === bundle ? item.quantity : 0);
      }, 0);
      if (!added) throw new Error((mainError || 'Could not add to cart.') + ' Please try again or contact us.');
      // Shopify doesn't cap at add; the cart page lowers anything over stock (ymg-cart-addons.js)

      var addons = addonIds.map(function(id) {
        return { id: id, quantity: added, properties: { 'For': forText, _ymg_bundle_of: bundle } };
      });
      return cartAdd(root, addons).then(function(result) {
        if (!result.ok) {
          throw new Error(product.title + ' was added to your cart, but an add-on could not be: ' +
            (result.data.description || 'unavailable') + ' Please contact us if you need it.');
        }
        window.location.href = root + 'cart';
      });
    }).catch(function(err) {
      showCartError(form, err.message);
      if (button) button.disabled = false;
    });
  }

  function cartAdd(root, items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(res) {
      return res.json().then(function(data) { return { ok: res.ok, data: data }; });
    });
  }

  /* Init ------------------------------------------------------------------- */

  function init(form) {
    var section = closestSection(form);
    var product = productJson(section);
    var wrapper = form.querySelector('[data-ymg-addons]');

    markUnavailable(form, product);
    updateConditions(form);
    form.addEventListener('change', function(e) {
      if (e.target.matches('[data-single-option-selector]')) markUnavailable(form, product);
      if (e.target.matches('[data-single-option-selector], [data-ymg-addon-input]')) updateConditions(form);
      if (e.target.matches('[data-ymg-addon-input]')) {
        var group = e.target.closest('[data-ymg-addon-group]');
        var error = group && group.querySelector('[data-ymg-addon-error]');
        if (error) { error.hidden = true; group.classList.remove('has-error'); }
      }
    });

    if (!wrapper || !product) return;

    form.addEventListener('submit', function(e) {
      if (!validate(wrapper)) { e.preventDefault(); return; }
      var ids = addonVariantIds(wrapper);
      if (!ids.length) return; // nothing extra: normal form post
      e.preventDefault();
      submitWithAddons(form, product, ids);
    });
  }

  function start() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
      if (form.querySelector('.ymg-pickers, [data-ymg-addons], [data-ymg-conditional]')) init(form);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
